import ButtonSmallMixin from './mixins/button-small-mixin.js';
import ButtonCtaMixin from './mixins/button-cta-mixin.js';
import ButtonShadow from './mixins/button-shadow-mixin.js';
import TpButton from './tp-button.js';

class TpButtonCtaSmall extends
  ButtonSmallMixin (
  ButtonCtaMixin (
  ButtonShadow(
    TpButton
  ))) {}

export default TpButtonCtaSmall;


